<template>
  <div class="page">
    <header>
      <NavBar :title="lang('订单详情')"> </NavBar>
    </header>
    <div class="main">
      <line style="height: 1px" />
      <card v-if="data" :data="data" />
      <div class="infoBox">
        <detail-line :list="detailList()" />
        <div v-if="data?.materialReceiptPhotos?.length > 0" class="confirmImg">
          <p>{{ lang('签收照片') }}</p>
          <div class="imageBox">
            <van-image
              v-for="(item, i) in data.materialReceiptPhotos"
              :key="i"
              :src="item"
              @click="preview(i)"
            />
          </div>
        </div>
      </div>
      <div class="detail">
        <titleLine
          v-for="item in list"
          :key="item.title"
          :data="item"
          :name-style="{ 'margin-bottom': '5px' }"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import NavBar from '@core/components/NavBar.vue'
import lang from '@/langs'
import { useRouter, useRoute } from 'vue-router'
import { onMounted, ref } from 'vue'
import Card from '@/views/score/component/orderDetail/card.vue'
import Line from '@core/components/line.vue'
import TitleLine from '@/views/score/component/scoreMain/titleLine.vue'
import DetailLine from '@/views/score/component/orderDetail/detailLine.vue'
import {
  MaterialRedeemDetailResp,
  MaterialRedeemResp
} from '@/model/score/score'
import { scoreRecordsDetail } from '@/api/requests/score'
import { showImagePreview, showToast } from 'vant'
import { loading } from '@core/utils/loading'
const router = useRouter()
const route = useRoute()
const id = route?.query?.data as string
const data = ref<MaterialRedeemDetailResp>()
const getDetail = () => {
  loading.show()
  scoreRecordsDetail({ id })
    .then((value) => {
      if (value.code === 1) {
        data.value = value.data
        list.value = listInitial()
      } else {
        showToast(
          lang(value?.msg) || ' Service exception, please try again later'
        )
      }
    })
    .finally(() => {
      loading.hide()
    })
}
const detailList = () => [
  {
    name: lang('实付积分'),
    value: data.value?.redeemPoints || '-'
  },
  {
    name: lang('订单编号'),
    value: data.value?.materialOrderNo || '-'
  },
  {
    name: lang('兑换时间'),
    value: data.value?.redeemTime || '-'
  }
]
const listInitial = () => [
  {
    title: lang('兑换须知'),
    sub1: lang('1.积分一经兑换不可退还,请谨慎兑换'),
    sub2: lang('2.兑换成功后,平台将在5个工作日内送达,请耐心等待')
  },
  {
    title: lang('商品详情'),
    sub1: data.value?.meterialDesc || '',
    sub2: ' '
  }
]
const list = ref(listInitial())
const preview = (i: number) => {
  showImagePreview({
    images: data?.value?.materialReceiptPhotos || [],
    startPosition: i
  })
}
onMounted(() => {
  getDetail()
})
</script>

<style scoped lang="less">
.page {
  height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;

  .main {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: scroll;

    .infoBox {
      background: #fff;

      .confirmImg {
        padding: 0 16px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-bottom: 16px;
        color: rgba(110, 110, 110, 1);
        font-size: 14px;

        .imageBox {
          flex: 1;
          display: flex;
          flex-direction: row;
          justify-content: flex-end;

          :deep(.van-image) {
            margin-left: 8px;
            width: 70px;
            height: 60px;
          }
        }
      }
    }

    .detail {
      display: flex;
      flex-direction: column;
      background: #fff;
      margin-top: 8px;
      padding-top: 16px;
    }
  }
}
</style>
